import {
    BOARD_ACTIVE_TAB,
    CMMC_MODULE_ACTIVE_TAB,
    INSIDER_BOARD_ACTIVE_TAB, NIST171_MODULE_ACTIVE_TAB,
} from 'constants/ActionTypes';

export function boardChangeActiveTab(newTab) {
    return {
        type: BOARD_ACTIVE_TAB,
        payload: newTab
    };
}

export function insiderBoardChangeActiveTab(newTab) {
    return {
        type: INSIDER_BOARD_ACTIVE_TAB,
        payload: newTab
    };
}

export function boardChangeActiveCMMCModuleTab(newTab) {
    return {
        type: CMMC_MODULE_ACTIVE_TAB,
        payload: newTab
    };
}

export function boardChangeActiveNIST171ModuleTab(newTab) {
    return {
        type: NIST171_MODULE_ACTIVE_TAB,
        payload: newTab
    };
}

